import { ReactNode } from 'react';

import Button from '../../../../../common/widgets/Button';

type MarketingBannerVariant = 'wide' | 'small';

interface MarketingHomePageBannerProps {
  variant: MarketingBannerVariant;
  title: ReactNode;
  description: ReactNode;
  actionLabel?: ReactNode;
  desktopImage: string;
  mobileImage: string;
  footer?: ReactNode;
  onAction?: () => void;
  loading?: boolean;
  isSuccess?: boolean;
}

export default function MarketingHomePageBanner({
  variant,
  title,
  description,
  actionLabel,
  desktopImage,
  mobileImage,
  footer,
  onAction,
  loading = false,
  isSuccess = false,
}: Readonly<MarketingHomePageBannerProps>) {
  const className = [
    'marketing-banner',
    `marketing-banner--${variant}`,
    isSuccess ? 'marketing-banner--success' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={className}>
      <div className="marketing-banner__content">
        <h3 className="marketing-banner__title">{title}</h3>

        <div className="marketing-banner__text">
          <p>{description}</p>
          {footer}
        </div>

        {actionLabel && (
          <div className="marketing-banner__action">
            <Button
              className="btn btn-solid marketing-banner__button"
              loading={loading}
              onClick={onAction ?? (() => undefined)}
            >
              <span className="btn-text">{actionLabel}</span>
            </Button>
          </div>
        )}
      </div>

      <div className="marketing-banner__image">
        <img
          className="marketing-banner__desktop-image"
          src={desktopImage}
          alt=""
          draggable={false}
        />
        <img
          className="marketing-banner__mobile-image"
          src={mobileImage}
          alt=""
          draggable={false}
        />
      </div>
    </div>
  );
}
